import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  CircularProgress,
} from "@mui/material";

const TratamientoDatosDialog = ({ open, onAccept, loading }) => {
  const [leido, setLeido] = useState(false);

  useEffect(() => {
    if (open) setLeido(false);
  }, [open]);

  const handleAccept = async () => {
    if (!leido || loading) return;
    await onAccept();
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
      }}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        Tratamiento de datos personales
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
          Antes de continuar, debes conocer y aceptar cómo BioPlastic / VIRTUS trata tu información personal.
        </Typography>

        <Box
          sx={{
            maxHeight: 320,
            overflowY: "auto",
            pr: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            p: 2,
            bgcolor: "#fafafa",
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
            Política de tratamiento de datos
          </Typography>
          <Typography variant="body2" paragraph sx={{ lineHeight: 1.7 }}>
            De conformidad con la Ley 1581 de 2012 y el Decreto 1377 de 2013, te informamos que los datos personales
            que proporcionas (nombre, correo electrónico, documento, teléfono, información académica y de uso de la
            plataforma) serán tratados por la Escuela Tecnológica Instituto Técnico Central (ETITC) y el Grupo de
            Investigación VIRTUS con las siguientes finalidades:
          </Typography>
          <Typography component="ul" variant="body2" sx={{ pl: 2.5, mb: 2, lineHeight: 1.7 }}>
            <li>Gestionar tu registro, autenticación y acceso a la plataforma.</li>
            <li>Administrar tu participación en cursos, evaluaciones y certificaciones.</li>
            <li>Generar reportes académicos, estadísticos y de seguimiento del proyecto.</li>
            <li>Enviar comunicaciones relacionadas con la actividad formativa o investigativa.</li>
            <li>Cumplir obligaciones legales y garantizar la seguridad de la información.</li>
          </Typography>
          <Typography variant="body2" paragraph sx={{ lineHeight: 1.7 }}>
            Como titular de los datos, tienes derecho a conocer, actualizar, rectificar y suprimir tu información,
            así como a revocar la autorización y presentar quejas ante la Superintendencia de Industria y Comercio.
          </Typography>
          <Typography variant="body2" sx={{ lineHeight: 1.7 }}>
            Al aceptar, autorizas el tratamiento de tus datos personales bajo las condiciones descritas. Si no estás
            de acuerdo, no podrás continuar utilizando la aplicación.
          </Typography>
        </Box>

        <FormControlLabel
          sx={{ mt: 2, alignItems: "flex-start" }}
          control={
            <Checkbox
              checked={leido}
              onChange={(e) => setLeido(e.target.checked)}
              sx={{ pt: 0.25 }}
            />
          }
          label="He leído y comprendo la información sobre el tratamiento de datos personales."
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAccept}
          disabled={!leido || loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {loading ? "Guardando..." : "Aceptar y continuar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TratamientoDatosDialog;
